__webpack_require__.p = "https://wxapp.gz-cmc.com/wxapp/2026/h5/signboard-h5/prod/";